import React, { memo } from "react";
import PropTypes from "prop-types";
import FuseDatePicker from "./FuseDatePicker";
import FuseCheckBox from "./FuseCheckBox";
import moment from "moment";
import _ from "lodash";
import FuseSelectInput from "./FuseSelectInput";
import { Form } from "react-bootstrap";
import FuseTextInput from "./FuseTextInput";
import FuseListOfValuesInput from "./FuseListOfValuesInput";
import { Checkbox } from "pretty-checkbox-react";
import FusePasswordInput from "./FusePasswordInput";
import FuseNumberInput from "./FuseNumberInput";
import FuseFileInput from "./FuseFileInput";

class FuseInputBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value
    };
  }

  static defaultProps = {
    value: ""
  };

  handleOnChange = (val, valid) => {
    // console.log(`(${this.props.type}) OnChange:`, val);
    this.setState({ value: this.applyCase(val) }, () => {
      this.props.onChange?.(this.state.value, valid, this.props);
    });
  };

  applyCase = (value) => {
    if (typeof value === "string") {
      if (this.props?.textCase === 1)
        //lower case
        return value?.toLowerCase();
      else if (this.props?.textCase === 0)
        //upper case
        return value?.toUpperCase();
    }
    //mixed case
    return value;
  };

  componentDidUpdate(prevProps) {
    if (!_.isEqual(prevProps.value, this.props.value)) {
      this.setState({ value: this.props.value });
    }
  }

  errorDiv = () => {
    let errors = this.getValidateErrors(this.state.value);
    return (
      /* Not using Form.Control.Feeback because there's a bootstrap bug (even using their own examples) that prevents it from working in columns */
      <div hidden={!this.props.editable || errors.length === 0} className="text-danger">
        {errors.map((x, index) => {
          return <div key={index}>{x}</div>;
        })}
      </div>
    );
  };

  _requiredAndEmpty = (val) => this.props.required === true && _.isEmpty(val);
  _requiredAndNull = (val) => (this.props.required === true && _.isNull(val)) || val === null;
  _notRequiredAndEmpty = (val) => !(this.props.required === true) && _.isEmpty(val);

  _requiredAndNotDate = (val) => this.props.required === true && !_.isDate(val);
  _requiredAndNotNumer = (val) => this.props.required === true && !_.isNumber(val);

  getErrorDescription(inputType, errorType) {
    switch (errorType) {
      case "Required": {
        return `This field is required and cannot be empty`;
      }
      case "minValue": {
        return `This field is has a min value of ${this.props?.minValue}`;
      }
      case "maxValue": {
        return `This field is has a max value of ${this.props?.maxValue}`;
      }
      case "minLength": {
        return `This field is has a min value of ${this.props?.minLength}`;
      }
      case "maxLength": {
        return `This field is has a max value of ${this.props?.maxLength}`;
      }
      default:
        return this.props?.regExpMissmatchMessage ? this.props?.regExpMissmatchMessage : `This field value is not valid`;
    }
  }

  getValidateErrors = (value) => {
    let errors = [];

    if (this._requiredAndEmpty(value) || this._requiredAndNull(value)) {
      errors.push(this.getErrorDescription(this.props.type, "Required"));
      return errors;
    }

    if (this.props?.regExp && this.props?.regExpMissmatchMessage) {
      if (!new RegExp(this.props.regExp).test(value)) {
        errors.push(this.getErrorDescription(this.props.type, this.props?.regExpMissmatchMessage));
        return errors;
      }
    }

    if (this.props.type === "int64" || this.props.type === "double" || this.props.type === "number" || this.props.type === "float") {
      if (value < this.props?.minValue) {
        errors.push(this.getErrorDescription(this.props.type, "minValue"));
        return errors;
      }

      if (value > this.props?.maxValue) {
        errors.push(this.getErrorDescription(this.props.type, "maxValue"));
        return errors;
      }

      if(!new RegExp(this.props.regExp).test(value)) {
        errors.push(this.getErrorDescription(this.props.type, "other"));
        return errors;
      }
    }

    if (this.props.type === "string" || this.props.type === "text" || this.props.type === "address_text" || this.props.type === "email") {
      if (value.toString().length < this.props?.minLength) {
        errors.push(this.getErrorDescription(this.props.type, "minLength"));
        return errors;
      }

      if (value.toString().length > this.props?.maxLength) {
        errors.push(this.getErrorDescription(this.props.type, "maxLength"));
        return errors;
      }

      if(!new RegExp(this.props.regExp).test(value)) {
        errors.push(this.getErrorDescription(this.props.type, "other"));
        return errors;
      }
    }

    // switch (this.props.type) {
    //   case "Boolean": {
    //     break;
    //   }
    //   default: {
    //     if (this._requiredAndEmpty(value)) {
    //       errors.push(this.getErrorDescription(this.props.type, "Required"));
    //       break;
    //     }
    //     break;
    //   }
    // }

    return errors;
  };

  _invalidErrorMessage = () => {
    let errors = this.getValidateErrors(this.state.value);
    if (errors.length > 0) {
      return this.getErrorDescription(this.props.type, errors[0]);
    } else return "";
  };

  checkValid = (value) => this.getValidateErrors(value).length === 0;
  isValid = () => this.checkValid(this.state.value);

  render() {
    const { type, id, value, editable, disabled, name, showErrors, isMulti, ...rest } = this.props;

    const displayClass = this.props?.editable === true ? "" : "d-flex align-items-center";
    const extraClasses = this.props?.classes ?? "";

    switch (type) {
      case "bool":
      case "boolean":
      case "Boolean": {
        return (
          <div className={`fuse-input-box-wrapper no-gutters fuse-form-control d-flex align-items-center justify-content-center`}>
            <FuseCheckBox {...this.props} onChange={this.handleOnChange} value={this.state.value} />
            {showErrors === true && this.errorDiv()}
          </div>
        );
      }
      case "file":
        return <div className="fuse-input-box-wrapper no-gutters fuse-form-control">
          <FuseFileInput
              {...this.props}
              onChange={this.handleOnChange}
          />
        </div>
      case "short_date":
      case "datetime":
      case "DateTime": {
        return (
          <div className={`fuse-input-box-wrapper no-gutters ${displayClass} ${extraClasses}`}>
            <FuseDatePicker {...this.props} onChange={this.handleOnChange} value={this.state.value} />
            {showErrors === true && this.errorDiv()}
          </div>
        );
      }

			case "drop_down":
      case "Dropdown":
      case "dropdown": {
        return (
          <div className={`fuse-input-box-wrapper no-gutters ${displayClass} ${extraClasses}`}>
            <FuseSelectInput {...this.props} onChange={this.handleOnChange} value={this.state.value} />
            {showErrors === true && this.errorDiv()}
          </div>
        );
      }
      case "lov":
      case "list_of_values": {
        return (
          <div className={`fuse-input-box-wrapper no-gutters ${displayClass} ${extraClasses}`}>
            <FuseListOfValuesInput {...this.props} onChange={this.handleOnChange} value={this.state.value} />
            {showErrors === true && this.errorDiv()}
          </div>
        );
      }
      case "password": {
        return (
          <div className={`fuse-input-box-wrapper no-gutters ${displayClass} ${extraClasses}`}>
            <FusePasswordInput {...this.props} onChange={this.handleOnChange} value={this.state.value} />
            {showErrors === true && this.errorDiv()}
          </div>
        );
      }
      case "number":
      case "Number":
      case "int":
      case "int16":
      case "int32":
      case "int64":
      case "Float":
      case "float":
      case "double":
      case "Double": {
        return (
          <div className={`fuse-input-box-wrapper no-gutters ${displayClass} ${extraClasses}`}>
            <FuseNumberInput {...this.props} onChange={this.handleOnChange} value={this.state.value} />
            {showErrors === true && this.errorDiv()}
          </div>
        );
      }
      default:
        return (
          <div className={`fuse-input-box-wrapper no-gutters ${displayClass} ${extraClasses}`}>
            <FuseTextInput {...this.props} onChange={this.handleOnChange} value={this.state.value} />
            {showErrors === true && this.errorDiv()}
          </div>
        );
    }
  }
}

FuseInputBox.propTypes = {
  //General
  type: PropTypes.string.isRequired,
  id: PropTypes.string,
  value: PropTypes.any,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  editable: PropTypes.bool,
  textCase: PropTypes.number,
  //text
  minLength: PropTypes.number,
  maxLength: PropTypes.number,
  regExp: PropTypes.string,
  regExpMissmatchMessage: PropTypes.string,
  //Number
  maxValue: PropTypes.number,
  minValue: PropTypes.number,
  //lov
  lovTable: PropTypes.string,
  lovKeyColumn: PropTypes.string,
  lovValueColumn: PropTypes.string,
  lovFilterKey: PropTypes.any,
  lovFilterValue: PropTypes.any,
  minAutoCompleteLength: PropTypes.number,
  //select
  isMulti: PropTypes.bool,
  dropDownValues: PropTypes.array,
  dropKeyColumn: PropTypes.string,
  dropValueColumn: PropTypes.string,
  //datetime
  dateFormat: PropTypes.string,
  maxDate: PropTypes.any,
  minDate: PropTypes.any
};

export default memo(FuseInputBox);
